import { render } from "./ContacInfoComp.vue?vue&type=template&id=3d5f97ee&scoped=true"
const script = {}

import "./ContacInfoComp.vue?vue&type=style&index=0&id=3d5f97ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d5f97ee"]])

export default __exports__